import { SvgIcon } from "@mui/material";
import { FC } from "react";

const AdminTagAliasIcon: FC<{
  active?: boolean;
  size?: number;
}> = ({ size = 24 }) => (
  <SvgIcon
    viewBox="0 0 24 24"
    aria-hidden="true"
    sx={{ fontSize: size, display: "block" }}
  >
    <path
      d="M6.75 8.25h4.4l3.7 3.7-4.65 4.65-3.45-3.45V8.25Z"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.7"
    />
    <circle cx="9.3" cy="10.75" r="0.8" fill="currentColor" />
    <path
      d="M13.65 8.2h4.1m-2.2-2 2.2 2-2.2 2"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.7"
    />
  </SvgIcon>
);

export default AdminTagAliasIcon;
